import { useState, useRef, useEffect } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Data from '../../data/Data';
import { Button, Form, Modal } from 'react-bootstrap';
import { XLg, Plus, ArrowLeftShort } from 'react-bootstrap-icons';
import DentalPositionInput from './DentalPositionInput';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';

function ProjectDetails() {
    const formRef = useRef();
    const [error, setError] = useState();
    const [validated, setValidated] = useState(false);
    const [project, setProject] = useState(undefined);
    const [oldProject, setOldProject] = useState(undefined);
    const [user, setUser] = useState(undefined);
    const [detailsMode, setDetailsMode] = useState(undefined);
    const [itemModal, setItemModal] = useState('');

    const userType = Data.getUserType();

    const navigate = useNavigate();

    const itemTypes = [
        { label: 'Polished', value: 'polished' },
        { label: 'Implant', value: 'implant' },
        { label: 'Bridge Item', value: 'bridge' }
    ];

    const implantFixations = [
        { label: 'Screw', value: 'screw' },
        { label: 'Cement', value: 'cement' }
    ];

    const getLocalDateTime = (date) => {
        const offset = date.getTimezoneOffset() * 60000; // Időzóna-eltolás ms-ban
        const localDate = new Date(date.getTime() - offset); // UTC -> helyi idő
        return localDate.toISOString().slice(0, 16); // Helyi idő string (YYYY-MM-DDTHH:mm)
    };

    const minDateTime = getLocalDateTime(new Date(Date.now() + 30 * 60 * 1000));

    useEffect(() => {
        const localStorageProject = localStorage.getItem('project');
        if (localStorageProject) {
            setProject(JSON.parse(localStorageProject));
            setDetailsMode(localStorage.getItem('detailsMode'));

            if (detailsMode)
                setOldProject(JSON.parse(localStorageProject));
        }

        fetchUser();
    }, [detailsMode]);

    async function fetchUser() {
        const fetchedUser = await Data.fetchUser();
        setUser(fetchedUser);
    }

    function checkBridges() {
        let isValid = true;

        // Create a new array with updated items
        const updatedItems = project.items.map(item => {
            // Skip validation for non-bridge items
            if (item.type !== 'bridge') {
                return { ...item, error: '' };
            }

            const teeth = item.teeth;
            const bridgeCount = teeth.filter(tooth => tooth.type === "bridge").length;
            const nonBridgeCount = teeth.length - bridgeCount;

            let error = '';

            console.log(teeth.length + ' ' + bridgeCount);

            if (teeth.length === 2 && bridgeCount > 1) {
                error = "For a 2-teeth bridge, only 1 tooth can be of type 'bridge'. The other must be 'polished' or 'implant'.";
                isValid = false;
            } else if (teeth.length >= 3 && nonBridgeCount < 2) {
                error = "For bridges with 3+ teeth, at least 2 teeth must be of type 'polished' or 'implant'.";
                isValid = false;
            }

            return { ...item, error };
        });

        // Update the project state with the validated items
        setProject(prevProject => ({
            ...prevProject,
            items: updatedItems
        }));

        return isValid;
    }

    async function handleCreate(e) {
        try {
            e.preventDefault();
            setError(null);
            let isValid = true;

            if (project.designers === undefined) {
                setValidated(true);
                isValid = false;
            }

            if (formRef.current.checkValidity() === false) {
                e.stopPropagation();
                setValidated(true);
                isValid = false;
            }

            if (checkBridges() === false) {
                setValidated(true);
                isValid = false;
            }

            if (isValid) {
                if (detailsMode === 'edit') {
                    await Data.modifyProject(project.id, {
                        "title": project.title,
                        "description": project.description,
                        "deliveryDeadline": project.deliveryDeadline,
                        "designer": project.designer.id,
                        "budgetType": project.budgetType,
                        "budget": project.budget,
                        "allowProposals": project.allowProposals
                    });
                    // TODO: successful modification message
                } else {
                    let jsonProject = JSON.parse(localStorage.getItem('project'));
                    jsonProject.designers = jsonProject.designers.map(designer => JSON.parse(designer).id);
                    jsonProject.budget = parseInt(jsonProject.budget);
                    await Data.createProject(JSON.stringify(jsonProject));
                    // TODO: successful creation message
                }

                navigate('/dashboard');
            }
        } catch (err) {
            console.error('Error creating project:', err);
            setError(err.message);
        }
    }

    function handleEdit() {
        setDetailsMode('edit');
        localStorage.setItem('detailsMode', 'edit');
        localStorage.setItem('project', JSON.stringify(project));
    }

    function handleArchive() {
        Data.setArchive(project.id);
        // setProjects(
        //     projects.map(x => {
        //         if (user.type === 'customer') {
        //             return x.id === project.id ? { ...x, archivedForCustomer: !x.archivedForCustomer } : x
        //         } else {
        //             return x.id === project.id ? { ...x, archivedForDesigner: !x.archivedForDesigner } : x
        //         }
        //     })
        // );
        // handleClose();
        navigate('/dashboard');
    }

    function handleCancelEdit() {
        setProject(oldProject);
        setDetailsMode('details');
        // clearStorage();
    }

    async function handleDecline() {
        try {
            await Data.acceptOrDenyProject(project.id, {
                status: 'declined'
            });

            navigate('/dashboard');
        }
        catch (err) {
            console.error('Error declining project:', error);
            setError(err.message);
        }
    }

    async function handleAccept() {
        try {
            await Data.acceptOrDenyProject(project.id, {
                status: 'accepted'
            });

            navigate('/dashboard');
        }
        catch (err) {
            console.error('Error declining project:', error);
            setError(err.message);
        }
    }

    function getFullName(designers) {
        if (Array.isArray(designers)) {
            return designers.map(designer => {
                try {
                    let parsedDesigner = typeof designer === 'string' ? JSON.parse(designer) : designer;
                    return `${parsedDesigner.firstName} ${parsedDesigner.lastName}`;
                } catch (ex) {
                    return '';
                }
            }).join(', ');
        }

        return '';
    }

    function addItem(type) {
        if (!project.items) {
            setProject(prevProject => ({
                ...prevProject,
                items: [],
            }));
        }

        setProject(prevProject => ({
            ...prevProject,
            items: [
                ...prevProject.items,
                {
                    type: type,
                    teeth: [],
                    material: '',
                }
            ]
        }));

        setItemModal('');
    }

    function removeItem(itemToRemove) {
        setProject(prevProject => ({
            ...prevProject,
            items: prevProject.items.filter(item => item !== itemToRemove)
        }));

        setItemModal('');
    }

    function updateProjectProperty(propertyName, value, index) {
        setProject(prevProject => {
            const updatedProject = { ...prevProject };

            if (index === undefined) {
                updatedProject[propertyName] = value;
            } else {
                const items = [...prevProject.items];
                items[index] = { ...items[index], [propertyName]: value };
                updatedProject.items = items;
            }

            localStorage.setItem('project', JSON.stringify(updatedProject));

            return updatedProject;
        });
    }

    function updateProjectItemProperty(index, position, value) {
        let items = project.items;
        const positionIndex = items[index].teeth.findIndex(x => x.position === position.position);
        if (positionIndex !== -1 && position.type !== value) {
            items[index].teeth[positionIndex] = {
                'position': position.position,
                'type': value
            };
        }

        setProject(prevProject => ({
            ...prevProject,
            items: items
        }));

        localStorage.setItem('project', JSON.stringify(project));
    }

    function updateProjectItemImplantProperty(index, position, properyName, value) {
        let items = project.items;
        const positionIndex = items[index].teeth.findIndex(x => x.position === position.position);
        if (positionIndex !== -1)
            items[index].teeth[positionIndex][properyName] = value;

        items[index].teeth[positionIndex][properyName] = value;

        setProject(prevProject => ({
            ...prevProject,
            items: items
        }));

        localStorage.setItem('project', JSON.stringify(project));
    }

    function getDisabledTeeth(index) {
        return project.items.filter((_, idx) => idx !== index).flatMap(item => item.teeth.map(tooth => tooth.position));
    }

    return (
        <div className="ProjectDetails">
            <Header background authButton sticky />
            {project && (
                <div className='container-fluid'>
                    <ArrowLeftShort className='btn-back btn-back-light' onClick={() => navigate('/dashboard')} />
                    <div className='container col-12 col-sm-10 col-lg-6'>
                        <h1>{detailsMode ? oldProject && oldProject.title : 'Set up a new project'}</h1>
                        {error && (
                            <Modal
                                show={!!error}
                                onHide={() => setError('')}
                                backdrop="static"
                                keyboard={false}
                                centered
                                size="sm"
                                className="error-modal"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Error</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {error}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="danger" onClick={() => setError('')}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        )}

                        <Form ref={formRef} className={`needs-validation ${validated ? 'was-validated' : ''}`} noValidate onSubmit={handleCreate}>
                            <Form.Group className="mb-3">
                                <Form.Label>Title:</Form.Label>
                                <Form.Control disabled={detailsMode === 'details'} type="text" required value={project.title ? project.title : ''} onChange={(e) => { updateProjectProperty('title', e.target.value); }} />
                                <Form.Control.Feedback type="invalid">Please provide a title.</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Description:</Form.Label>
                                <Form.Control disabled={detailsMode === 'details'} as="textarea" style={{ resize: "none" }} rows={3} maxLength={255} required value={project.description} onChange={(e) => { updateProjectProperty('description', e.target.value); }} />
                                <Form.Control.Feedback type="invalid">Please provide a description.</Form.Control.Feedback>
                            </Form.Group>

                            <p>Items:</p>
                            {project.items && project.items !== null && project.items.map((item, index) => (
                                <div className='col-12 box-tooth d-flex justify-content-center align-items-center mt-1 mb-4' key={index}>
                                    <div className='col-12 px-4 py-3'>
                                        <div className='d-flex justify-content-end'>
                                            <XLg className='close-button' onClick={() => setItemModal(item)} />
                                        </div>

                                        <h4>{item.type.charAt(0).toUpperCase() + item.type.slice(1)}</h4>

                                        <DentalPositionInput multiple={item.type === 'bridge'}
                                            project={project} setProject={setProject}
                                            index={index}
                                            disabledTeeth={getDisabledTeeth(index)}
                                            disabled={detailsMode} />

                                        <Form.Group className="mb-3">
                                            <Form.Label>Material:</Form.Label>
                                            <Form.Control disabled={detailsMode === 'details'} type="text" required value={item.material} onChange={(e) => { updateProjectProperty(`material`, e.target.value, index); }} />
                                            <Form.Control.Feedback type="invalid">Please provide a material.</Form.Control.Feedback>
                                        </Form.Group>

                                        {item.teeth.map(position => (
                                            <div key={position.position}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tooth {position.position} Type:</Form.Label>
                                                    <Form.Select disabled={detailsMode === 'details'} required value={position.type} onChange={(e) => { updateProjectItemProperty(index, position, e.target.value); }}>
                                                        <option value="" disabled>Select Type</option>
                                                        {itemTypes.filter(type => item.type === 'crown' && type.value === 'bridge' ? false : true).map(type => (
                                                            <option key={type.value} value={type.value}>{type.label}</option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">Please select a type.</Form.Control.Feedback>
                                                </Form.Group>

                                                {position.type === 'implant' && (
                                                    <div className='border-bottom mb-3'>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Implant Type:</Form.Label>
                                                            <Form.Control disabled={detailsMode === 'details'} type="text" required value={position.implant_type} onChange={(e) => { updateProjectItemImplantProperty(index, position, 'implant_type', e.target.value); }} />
                                                            <Form.Control.Feedback type="invalid">Please provide a material.</Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Implant Scan Body:</Form.Label>
                                                            <Form.Control disabled={detailsMode === 'details'} type="text" required value={position.scan_body} onChange={(e) => { updateProjectItemImplantProperty(index, position, 'scan_body', e.target.value); }} />
                                                            <Form.Control.Feedback type="invalid">Please provide a material.</Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Select Fixation:</Form.Label>
                                                            <Form.Select disabled={detailsMode === 'details'} required value={position.fixation} onChange={(e) => { updateProjectItemImplantProperty(index, position, 'fixation', e.target.value); }}>
                                                                <option value="" disabled>Select Fixation</option>
                                                                {implantFixations.map(implantFixation => (
                                                                    <option key={implantFixation.value} value={implantFixation.value}>{implantFixation.label}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Please select a type.</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                )
                                                }
                                            </div>
                                        ))}
                                        {(item.error !== '' && item.error !== undefined) && (
                                            console.log(item),

                                            <div className="alert alert-danger alert-dismissible" role="alert">
                                                {item.error}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}

                            {[null, 'edit'].includes(detailsMode) && (<div className='col-12 box-tooth-empty d-flex justify-content-center align-items-center mt-1 mb-4' onClick={() => setItemModal('add')}>
                                <Plus />
                            </div>)}

                            <Form.Label>{user && userType === 'customer' ? 'Select Designer:' : 'Customer'}</Form.Label>
                            {
                                detailsMode === 'details' ?
                                    <Form.Control className='mb-3' disabled type="text" required value={user && userType === 'customer' ? getFullName(project.designers) : getFullName(project.customer)} />
                                    :
                                    <div>
                                        <div>
                                            <Form.Check
                                                type="radio"
                                                label="Select a Designer"
                                                name="designerOption"
                                                id="selectDesigner"
                                                value="selectDesigner"
                                                checked={project.allowProposals === false}
                                                onChange={() => updateProjectProperty('allowProposals', false)}
                                                disabled={detailsMode === 'details'}
                                                className='mb-2'
                                            />
                                            <Form.Check
                                                type="radio"
                                                label="Anyone Can Make an Offer"
                                                name="designerOption"
                                                id="anyoneOffer"
                                                value="anyoneOffer"
                                                checked={project.allowProposals === true}
                                                onChange={() => updateProjectProperty('allowProposals', true)}
                                                disabled={detailsMode === 'details'}
                                                className='mb-3'
                                            />
                                        </div>
                                        {
                                            project.allowProposals === false && (
                                                <InputGroup className="mb-3">
                                                    <FormControl
                                                        placeholder="Designer's name"
                                                        aria-label="Designer's name"
                                                        aria-describedby="basic-addon2"
                                                        required
                                                        readOnly
                                                        disabled
                                                        value={getFullName(project.designers)}
                                                        isInvalid={validated && project.designers.length === 0}
                                                    />
                                                    <Button
                                                        style={{ borderTopRightRadius: "7px", borderBottomRightRadius: "7px" }}
                                                        variant="outline-primary" id="button-addon2"
                                                        onClick={() => { window.location.href = "/designers" }}
                                                    >
                                                        Select designer
                                                    </Button>
                                                    <Form.Control.Feedback type="invalid">Please select a designer.</Form.Control.Feedback>
                                                </InputGroup>
                                            )
                                        }
                                    </div>
                            }

                            <Form.Group className="mb-3">
                                <Form.Label>Delivery Deadline:</Form.Label>
                                <Form.Control disabled={detailsMode === 'details'} type="datetime-local" min={minDateTime} required value={project.deliveryDeadline ? project.deliveryDeadline.slice(0, 16) : ''} onChange={(e) => { updateProjectProperty(`deliveryDeadline`, e.target.value); }} />
                                <Form.Control.Feedback type="invalid">Please provide a valid deadline. Deadline must be half an hour later than now.</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Select Budget Type:</Form.Label>
                                <div>
                                    <Form.Check
                                        type="radio"
                                        label="Budget per Tooth"
                                        name="budgetType"
                                        id="budgetPerTooth"
                                        value="tooth"
                                        checked={project.budgetType === 'tooth'}
                                        onChange={() => updateProjectProperty('budgetType', 'tooth')}
                                        disabled={detailsMode === 'details'}
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="Budget per Project"
                                        name="budgetType"
                                        id="budgetPerProject"
                                        value="project"
                                        checked={project.budgetType === 'project'}
                                        onChange={() => updateProjectProperty('budgetType', 'project')}
                                        disabled={detailsMode === 'details'}
                                    />
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Budget (EUR):</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter price in EUR"
                                    value={project.budget}
                                    disabled={detailsMode === 'details'}
                                    onChange={(e) => updateProjectProperty('budget', e.target.value)}
                                />
                            </Form.Group>
                        </Form>

                        {/* top of the page */}
                        {detailsMode === null &&
                            <Button variant="primary" type="submit" onClick={handleCreate}>
                                Create
                            </Button>
                        }
                        {detailsMode === 'edit' &&
                            <Button variant="outline-primary" onClick={handleCancelEdit}>Cancel</Button>
                        }
                        {detailsMode === 'edit' &&
                            <Button variant="primary" type="submit" onClick={handleCreate}>
                                Save
                            </Button>
                        }
                        {(['completed', 'declined'].includes(project.status) && user && !detailsMode === 'edit') && (
                            <Button variant="outline-primary" onClick={handleArchive}>
                                {userType === 'customer'
                                    ? (project.archivedForCustomer ? 'Unarchive' : 'Archive')
                                    : (project.archivedForDesigner ? 'Unarchive' : 'Archive')
                                }
                            </Button>
                        )}
                        {project.status === 'declined' && user && userType === 'customer' && detailsMode !== 'edit' &&
                            <Button variant="primary" onClick={handleEdit}>Edit</Button>
                        }
                        {
                            user && userType === 'designer' && project.status === 'awaiting' &&
                            <Button variant="outline-danger " onClick={handleDecline}>Decline</Button>
                        }
                        {
                            user && userType === 'designer' && project.status === 'awaiting' &&
                            <Button variant="success" onClick={handleAccept}>Accept</Button>
                        }
                    </div>
                </div>
            )}

            {itemModal !== '' && (
                <Modal show={true} onHide={() => setItemModal('')} backdrop="static" keyboard={false} centered size="sm" scrollable fullscreen="sm-down" className="tooth-modal">
                    <Modal.Header closeButton />
                    {itemModal === 'add' ? (
                        <Modal.Body>
                            What type of item do you want to add?
                            <div className='row mt-2'>
                                <div className='col-12 d-flex justify-content-end'>
                                    <Button className='btn-sm me-2' onClick={() => addItem('crown')}>Crown</Button>
                                    <Button className='btn-sm' onClick={() => addItem('bridge')}>Bridge</Button>
                                </div>
                            </div>
                        </Modal.Body>
                    ) : (
                        <Modal.Body>
                            Are you sure to delete this element?
                            <div className='row mt-2'>
                                <div className='col-12 d-flex justify-content-end'>
                                    <Button className='btn-sm me-2' onClick={() => setItemModal('')}>Cancel</Button>
                                    <Button className='btn-sm btn-danger' onClick={() => removeItem(itemModal)}>Delete</Button>
                                </div>
                            </div>
                        </Modal.Body>
                    )}
                </Modal>
            )}
        </div>
    );
}

export default ProjectDetails;